import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import AlertDialogSlide from '../share/AlertDialogSlide';
import AcertoMensalidadeService from '../../services/AcertoMensalidadeService';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class ToolbarAcertoMensalidadeSelect extends React.Component {
  acertosService = new AcertoMensalidadeService();
  state = {
    openDialog: false,
  }

  handleClickProcessar = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleDialogConfirm = async () => {
    this.setState({ openDialog: false });
    this.props.handleClickToolBar();

    let registrosComErros = [];
    let registrosSemErros = [];
    let msgRetornoResumida = '';
    let registroComErro = {
      registro: '',
      mensagens: []
    };
    let result = {
      registrosComErros: [],
      registrosSemErros: [],
      msgRetornoResumida: ''
    };
    let retorno = {};

    for (var i = 0; i < this.props.selectedRows.data.length; i++) {
      retorno = await this.acertosService.processarAcerto(Number(this.props.displayData[this.props.selectedRows.data[i].index].data[0]));
      if (retorno !== undefined && retorno !== null) {
        if (retorno.data.codigoRetorno === 1) {
          registrosSemErros.push(retorno.data.registrosSemErros[0]);
          msgRetornoResumida = retorno.data.msgRetornoResumida;
        } else {
          registrosComErros.push(retorno.data.registrosComErros[0]);
        }
      } else {
        registroComErro.registro = this.props.displayData[this.props.selectedRows.data[i].index].data[0].props.children;
        let mensagem = ['Nao foi possivel realizar a operacao'];
        registrosComErros.mensagens.push(mensagem);
      }
    }
    result.registrosSemErros = registrosSemErros;
    result.msgRetornoResumida = msgRetornoResumida;
    result.registrosComErros = registrosComErros;
    this.props.setSelectedRows([]);
    this.props.onOperacaoFinalizada(result);
  };

  render () {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Button
            variant='contained'
            className={classes.button}
            onClick={this.handleClickProcessar}
            color='primary'
            size='small'
            title='Processar'>
            <CheckIcon className={classes.button} />
            Processar Acertos
          </Button>
        </div>
        <AlertDialogSlide
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          handleClick={this.handleDialogConfirm}
          title={'Processar Acerto(s)...'}
          message={`${this.props.selectedRows.data.length}
                    acerto(s) selecionado(s). Deseja processar o(s) registro(s)? Esta operação envia os valores para a FOLHA DE PAGAMENTO com a rubrica 9580.
                    Depois de confirmada, esta operação não poderá mais ser desfeita!`} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ToolbarAcertoMensalidadeSelect);
